var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNotinsale = function SvgNotinsale(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 36,
    width: 84,
    height: 44,
    rx: 8,
    fill: "#E6E8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0977 47.5977V56H52.2988V52.5781H48.7012V56H46.8965V47.5977H48.7012V50.9609H52.2988V47.5977H54.0977ZM61.4805 53.5977H57.2207C57.2832 53.918 57.4531 54.1895 57.7305 54.4121C58.0078 54.6309 58.3574 54.7402 58.7793 54.7402C59.084 54.7402 59.3652 54.6816 59.623 54.5645C59.8848 54.4434 60.0684 54.3223 60.1738 54.2012L60.3438 54.0195L61.1816 55.0977L61.0762 55.2031C61.0254 55.2539 60.9199 55.3379 60.7598 55.4551C60.5996 55.5723 60.4297 55.6777 60.25 55.7715C60.0703 55.8613 59.8359 55.9414 59.5469 56.0117C59.2617 56.082 58.9668 56.1172 58.6621 56.1172C57.7988 56.1172 57.0625 55.8184 56.4531 55.2207C55.8438 54.6191 55.5391 53.8984 55.5391 53.0586C55.5391 52.2188 55.8398 51.5 56.4414 50.9023C57.043 50.3008 57.7637 50 58.6035 50C59.4434 50 60.1426 50.2812 60.7012 50.8438C61.2598 51.4023 61.5391 52.1016 61.5391 52.9414L61.4805 53.5977ZM59.4707 51.6875C59.2363 51.4844 58.9473 51.3828 58.6035 51.3828C58.2598 51.3828 57.9668 51.4824 57.7246 51.6816C57.4863 51.8809 57.3184 52.1406 57.2207 52.4609H59.9219C59.8594 52.1484 59.709 51.8906 59.4707 51.6875ZM62.1426 51.6816V50.1172H67.4863V51.6816H65.623V56H64.0059V51.6816H62.1426ZM30.0742 62.1172H33.0156C33.6016 62.1172 34.0781 62.2773 34.4453 62.5977C34.8125 62.918 34.9961 63.2988 34.9961 63.7402C34.9961 64.0059 34.9355 64.2383 34.8145 64.4375C34.6934 64.6367 34.5723 64.7676 34.4512 64.8301L34.2754 64.9414C34.2988 64.9492 34.332 64.9609 34.375 64.9766C34.418 64.9922 34.4961 65.0371 34.6094 65.1113C34.7227 65.1816 34.8203 65.2637 34.9023 65.3574C34.9883 65.4473 35.0645 65.5723 35.1309 65.7324C35.2012 65.8926 35.2363 66.0684 35.2363 66.2598C35.2363 66.7559 35.0449 67.1699 34.6621 67.502C34.2832 67.834 33.7734 68 33.1328 68H30.0742L30.0742 62.1172ZM33.0156 65.4805H31.6914V66.6816H33.0156C33.1992 66.6816 33.3438 66.625 33.4492 66.5117C33.5586 66.3984 33.6133 66.2539 33.6133 66.0781C33.6133 65.9023 33.5586 65.7598 33.4492 65.6504C33.3438 65.5371 33.1992 65.4805 33.0156 65.4805ZM32.8926 64.4023C33.2129 64.4023 33.373 64.2422 33.373 63.9219C33.373 63.6016 33.2129 63.4414 32.8926 63.4414H31.6914V64.4023H32.8926ZM40.5156 65.7793V68H38.8984V62.1172H40.5156V64.3379H42.7949V62.1172H44.418V68H42.7949V65.7793H40.5156ZM49.2168 68V67.4023C49.1699 67.457 49.1035 67.5254 49.0176 67.6074C48.9355 67.6855 48.7539 67.791 48.4727 67.9238C48.1914 68.0527 47.8984 68.1172 47.5938 68.1172C47.0078 68.1172 46.5312 67.9551 46.1641 67.6309C45.7969 67.3027 45.6133 66.9062 45.6133 66.4414C45.6133 65.9609 45.7676 65.5605 46.0762 65.2402C46.3848 64.9199 46.8105 64.7109 47.3535 64.6133L49.2168 64.2793C49.2168 64.0332 49.127 63.832 48.9473 63.6758C48.7676 63.5195 48.5176 63.4414 48.1973 63.4414C47.9316 63.4414 47.6895 63.4922 47.4707 63.5938C47.252 63.6914 47.0977 63.793 47.0078 63.8984L46.873 64.0391L45.9766 63.1426C46 63.1113 46.0312 63.0703 46.0703 63.0195C46.1133 62.9648 46.2051 62.873 46.3457 62.7441C46.4902 62.6152 46.6465 62.502 46.8145 62.4043C46.9824 62.3027 47.2031 62.2109 47.4766 62.1289C47.75 62.043 48.0293 62 48.3145 62C49.0566 62 49.6621 62.2227 50.1309 62.668C50.5996 63.1094 50.834 63.666 50.834 64.3379V68H49.2168ZM48.0156 66.7988C48.3828 66.7988 48.6738 66.6836 48.8887 66.4531C49.1074 66.2188 49.2168 65.8945 49.2168 65.4805V65.2988L47.8984 65.5391C47.457 65.6094 47.2363 65.8301 47.2363 66.2012C47.2363 66.5996 47.4961 66.7988 48.0156 66.7988ZM52.9961 62.1172H57.7363V68H56.1191V63.5586H54.5605V63.9219C54.5605 65.0195 54.4668 65.8926 54.2793 66.541C54.0957 67.1855 53.8574 67.6211 53.5645 67.8477C53.2754 68.0703 52.9062 68.1816 52.457 68.1816C52.3125 68.1816 52.1699 68.1641 52.0293 68.1289C51.8926 68.0977 51.791 68.0703 51.7246 68.0469L51.6191 68V66.5586C51.7402 66.5977 51.8594 66.6172 51.9766 66.6172C52.2148 66.6172 52.4023 66.5566 52.5391 66.4355C52.6758 66.3105 52.7852 66.0352 52.8672 65.6094C52.9531 65.1797 52.9961 64.5566 52.9961 63.7402V62.1172ZM63.4668 62.1172H64.8789V68H63.2617V64.7012L60.7012 68H59.3008V62.1172H60.918V65.4219L63.4668 62.1172ZM69.918 68V66.0195C69.5195 66.3008 69.0586 66.4414 68.5352 66.4414C67.8633 66.4414 67.3242 66.2285 66.918 65.8027C66.5156 65.373 66.3145 64.7852 66.3145 64.0391V62.1172H67.9375V63.9219C67.9375 64.2188 68.0293 64.4629 68.2129 64.6543C68.3965 64.8457 68.625 64.9414 68.8984 64.9414C69.0898 64.9414 69.2715 64.9121 69.4434 64.8535C69.6152 64.791 69.7363 64.7285 69.8066 64.666L69.918 64.5781V62.1172H71.5352V68H69.918ZM77.2598 62.1172H78.6719V68H77.0547V64.7012L74.4941 68H73.0938V62.1172H74.7109V65.4219L77.2598 62.1172ZM84.3965 62.1172H85.8086V68H84.1914V64.7012L81.6309 68H80.2305V62.1172H81.8477V65.4219L84.3965 62.1172Z",
    fill: "#6F7880"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 37.5,
    width: 81,
    height: 41,
    rx: 6.5,
    stroke: "white",
    strokeWidth: 3
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: -12,
    y: -11,
    width: 140,
    height: 140,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.415686 0 0 0 0 0.478431 0 0 0 0 0.596078 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 4,
    y: 25,
    width: 108,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.415686 0 0 0 0 0.478431 0 0 0 0 0.596078 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNotinsale, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/notinsale.9b5c1c22.svg";
export { ForwardRef as ReactComponent };